import React, { useEffect } from 'react';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './trackingMap.css';
import { DEFAULT_MAP_CENTER, DEFAULT_MAP_ZOOM, TILE_URL, TILE_ATTRIBUTION } from '../../utils/constants';

// Fix Leaflet default icon paths for Vite bundler
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

L.Icon.Default.mergeOptions({ iconUrl, iconRetinaUrl, shadowUrl });

interface TrackingMapProps {
  children?: React.ReactNode;
  /** Pass a changing value to trigger map resize (e.g. panel open/close state) */
  resizeSignal?: boolean;
}

/** Inner component that invalidates map size on mount and when resizeSignal changes */
function MapResizeHandler({ resizeSignal }: { resizeSignal?: boolean }) {
  const map = useMap();
  useEffect(() => {
    // Invalidate after CSS transition (300ms) completes
    const timer = setTimeout(() => map.invalidateSize(), 350);
    return () => clearTimeout(timer);
  }, [map, resizeSignal]);
  return null;
}

export const TrackingMap: React.FC<TrackingMapProps> = ({ children, resizeSignal }) => {
  return (
    <MapContainer
      center={DEFAULT_MAP_CENTER}
      zoom={DEFAULT_MAP_ZOOM}
      className="h-full w-full"
      zoomControl={true}
      scrollWheelZoom={true}
    >
      <TileLayer url={TILE_URL} attribution={TILE_ATTRIBUTION} />
      <MapResizeHandler resizeSignal={resizeSignal} />
      {children}
    </MapContainer>
  );
};
